import React from 'react';
import {connect} from 'react-redux';
import {Row, Col, FormGroup, ControlLabel, Form, Button} from 'react-bootstrap';
import {calcTotals, getJoinSelectedItems, getNextDeliveryDate, getAllItemsRemainingDeliveryDates} from '../../common/basket';
import {selectPaymentPlan, applyCoupon, removeCoupon, isValidateCouponMinimum, setCouponStatus} from '../../actions/join/joinActions';
import {FetchingTypes, PaymentPlans, CouponStatus} from '../../common/constants';
import {isEmptyString} from '../../common/utils';
import Coupon from "../../components/coupon/Coupon";
import {translate} from '../../i18n/translate.js';
import ModalPopup from "../../components/common/ModalPopup";
import styles from "../../css/join/joinTermsStep.less";

class JoinTermsStep extends React.Component {
    state = {
        disabledApply: true
    };

    componentDidMount() {
        for (let ref in this.refs) {
            if (this.refs.hasOwnProperty(ref)) {
                const elem = this.refs[ref];
                if (elem.className === "list-row-comment")
                    if (elem.scrollHeight > 42) {
                        ref = ref.replace("comment_", "more_");
                        this.refs[ref].style.display = "block"
                    }
            }
        }
    }

    expendComment = (e) => {
        let id = e.target.id;
        this.refs[id].style.display = "none";
        id = id.replace("more_", "comment_");
        this.refs[id].style.maxHeight = "initial";
    };

    getNote = (plan) => {
        if (this.props.clientViewPort.isXs) {
            return (<Col name="planNote" sm={6} xs={11} className="term-col plan-note">
                <div className="list-row-comment" id={"comment_" + plan.key} ref={"comment_" + plan.key}
                     dangerouslySetInnerHTML={{__html: plan.note}}/>
            </Col>);
        } else {
            return (<Col name="planNote" sm={6} xs={11} className="term-col plan-note">
                <div>{plan.note}</div>
            </Col>);
        }
    };

    onPaymentPlanSelected = (paymentPlan) => {
        if (this.props.paymentPlan.key === paymentPlan)
            return;
        this.props.selectPaymentPlan(paymentPlan);
    };

    onApplyCouponClicked = (couponId) => {
        if (couponId.length > 0 || this.props.couponStatus === CouponStatus.INVALID) {
            this.props.applyCoupon(couponId);
        }
    };

    onRemoveCouponClicked = () => {
        this.props.removeCoupon();
    };

    onChangeCouponId = (event) => {
        const couponId = event.target.value;
        let invalidStatus = this.state.invalidStatus;
        if(invalidStatus && isEmptyString(couponId)) {
            invalidStatus = undefined;
        }
        this.setState({disabledApply: isEmptyString(couponId), invalidStatus});
    };

    getColumns = () => {
        if(this.props.clientViewPort.isXs) {
            return null;
        } else {
            return (<Form horizontal className="list-container term-titles">
                <FormGroup className="columns-title" controlId="termsTitles">
                    <Col componentClass={ControlLabel} className="title-column" sm={4}>{translate("Payment Plan")}</Col>
                    <Col componentClass={ControlLabel} className="title-column" sm={2}>{translate("Price")}</Col>
                    <Col componentClass={ControlLabel} className="title-column" sm={6}>{translate("Notes")}</Col>
                </FormGroup>
            </Form>);
        }
    };

    getPaymentPlan = (plan) => {
        return (
            <Row name="paymentRow" key={plan.key} className="list-row term-row">
                <Row onClick={this.onPaymentPlanSelected.bind(this, plan.key)} className="term-row-click-container">
                    <Col sm={4} xs={12}>
                        <div className="list-item-title">
                            <input name="selectPayment" type="radio" value={plan.key}
                                   className="radio-select"
                                   onChange={this.onPaymentPlanSelected.bind(this, plan.key)}
                                   checked={this.props.paymentPlan.key === plan.key}/>
                            <div className="item-title plan-title" name="planTitle">{plan.title}</div>
                        </div>
                    </Col>
                    <Col name="planPrice" className="term-col plan-title" xs={8} sm={2}>
                        {plan.type === PaymentPlans.OneWeekDebit ? '' : this.props.paymentsPrice[plan.key]}
                    </Col>
                    {this.getNote(plan)}
                </Row>
                {this.props.clientViewPort.isXs ?
                    <Col name="planNote" xs={11} className="term-col plan-note">
                        <div className="read-more-comment" id={"more_" + plan.key} ref={"more_" + plan.key}
                             onClick={this.expendComment}>{translate("More") + "..."}
                        </div>
                    </Col> : undefined
                }
            </Row>);
    };

    componentWillReceiveProps(nextProps) {
        if(nextProps.couponStatus !== this.props.couponStatus && this.props.couponStatus  === CouponStatus.VALIDATING) {
            let invalidStatus;
            if(nextProps.coupon && !isValidateCouponMinimum(nextProps.coupon, this.props.signupData.sharesData, this.props.staticData)) {
                invalidStatus = !nextProps.coupon.calculateOptions?translate(CouponStatus.INVALID_COUPON_MINIMUM).replace("{0}", nextProps.coupon.minimumOrder):translate(CouponStatus.INVALID_COUPON_MINIMUM_WITH_OPTIONS).replace("{0}", nextProps.coupon.minimumOrder);
            } else if(nextProps.couponStatus === CouponStatus.INVALID) {
                invalidStatus = translate(CouponStatus.INVALID_COUPON);
            }
            this.setState({invalidStatus});
            if(nextProps.coupon && nextProps.coupon.couponType !== "Subscription" || (nextProps.coupon && !nextProps.coupon.couponType) || invalidStatus) {
                this.props.removeCoupon();
            }
            if(!nextProps.coupon && !invalidStatus) {
                setCouponStatus(CouponStatus.INVALID_COUPON);
            }
        }
    }

    getCoupon = () => {
        if(this.props.hasCoupons) {
            return (<Coupon couponStatus={this.props.couponStatus} invalidStatus={this.state.invalidStatus}
                            coupon={this.props.coupon} removeCoupon={this.onRemoveCouponClicked}
                            onChangeCouponId={this.onChangeCouponId} disabledApply={this.state.disabledApply}
                            onApplyCouponClicked={this.onApplyCouponClicked}/>);
        } else {
            return null;
        }
    };

    showCouponValidationPopup = () => {
      if(this.props.coupon && this.props.coupon.status === CouponStatus.INVALID_COUPON_MINIMUM) {
          return (<ModalPopup
              onClose={() => {
                  this.props.setCouponStatus(undefined);
              }}
              message={!this.props.coupon.calculateOptions?translate(CouponStatus.INVALID_COUPON_MINIMUM).replace("{0}", this.props.coupon.minimumOrder):
                  translate(CouponStatus.INVALID_COUPON_MINIMUM_WITH_OPTIONS).replace("{0}", this.props.coupon.minimumOrder)}
              middle={{
                  text: 'Close', callback: () => {
                      this.props.setCouponStatus(undefined);
                  }
              }}/>);
      }
    };

    render() {
        return (
            <div className="table-container-selector">
                {
                    !this.props.clientViewPort.isXs?
                        <div className="select-title">{translate("PaymentPlanStep.heading")}</div>:undefined
                }
                <div className="pay-container">
                    {this.getColumns()}
                    {this.props.paymentPlans.map(plan => {{return this.getPaymentPlan(plan)}}
                    )}
                </div>
                {this.getCoupon()}
                {this.showCouponValidationPopup()}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const signupData = (state.signupData || {});
    const staticData = state.staticData;
    const summary = (state.summary || {});
    let selectedData = (signupData.selectedData || {});
    let paymentsPrice = {};
    const selectedItems =  getJoinSelectedItems(signupData.sharesData.shares, signupData.sharesData.options).items;
    const nextDeliveryDate = getNextDeliveryDate(summary.pickupSite, selectedItems,
        signupData.schedules, signupData.pickupSitesData.nextDeliveryDates);
    const itemsRemainingDates = getAllItemsRemainingDeliveryDates(selectedItems, signupData.sharesData.remainingScheduleDates);

    signupData.paymentPlans.map(plan => {
        paymentsPrice[plan.key] = calcTotals(signupData.data.isFarmSeasonal, summary.pickupSite,
            selectedItems, plan, selectedData.coupon, itemsRemainingDates, signupData.sharesData.remainingScheduleDates,
            nextDeliveryDate, signupData.isAddSubscription, summary.discount, staticData, selectedData.selectedMethod).priceText;
        if (paymentsPrice[plan.key] === "$0")
            paymentsPrice[plan.key] = "";
    });

    //Since add subscription can't create token, in case of member without token we need to present only payment plans which works with standard (single) payment methods.
    //Therefore the installments and the one week debit shouldn't be presented.
    const paymentPlans = (!signupData.isAddSubscription || summary.hasPreapproval) ? signupData.paymentPlans : signupData.paymentPlans.filter(function(paymentPlan){
        return paymentPlan.type !== PaymentPlans.AutoRecurring &&
            paymentPlan.type !== PaymentPlans.PresetRecurring &&
            paymentPlan.type !== PaymentPlans.OneWeekDebit &&
            paymentPlan.type !== PaymentPlans.DistributionDynamicPrePayment;
    });

    const paymentPlanSorted = paymentPlans.slice(0).sort((a,b) =>{
        return a.order - b.order;
    });
    let couponStatus = (state.fetching.isFetching && state.fetching.fetchingType === FetchingTypes.VALIDATE_COUPON) ? CouponStatus.VALIDATING :
        !selectedData.coupon ? CouponStatus.NONE :
            selectedData.coupon.valid && (selectedData.coupon.couponType === "Subscription" || !selectedData.coupon.couponType)? CouponStatus.VALID : CouponStatus.INVALID;
    return {
        clientViewPort: (state.clientViewPort || {}),
        staticData: staticData,
        signupData: signupData,
        paymentPlan: (selectedData.selectedPaymentPlan || {}),
        paymentPlans: paymentPlanSorted,
        paymentsPrice: paymentsPrice,
        hasCoupons: signupData.data.hasCoupons && !signupData.isAddSubscription,
        coupon: selectedData.coupon,
        couponStatus: couponStatus
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        selectPaymentPlan: (key) => {
            dispatch(selectPaymentPlan(key));
        },
        applyCoupon: (couponId) => {
            dispatch(applyCoupon(couponId));
        },
        removeCoupon: () => {
            dispatch(removeCoupon());
        },
        setCouponStatus: (status) => {
            dispatch(setCouponStatus(status));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)( JoinTermsStep );


// WEBPACK FOOTER //
// ./src/containers/join/JoinTermsStep.js